import React, { useState } from 'react';
import axios from 'axios';
import '../styles/ProductForm.css';

const ProductForm = ({ onProductAdded, onCancel }) => {
  const [formData, setFormData] = useState({
    prod_code: '',
    prod_name: '',
    prod_description: '',
    prod_price: '',
    prod_stock: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setError('No se encontró un token de autenticación. Por favor, inicie sesión nuevamente.');
        return;
      }

      // Validar campos requeridos
      if (!formData.prod_name || !formData.prod_price) {
        setError('El nombre y el precio son obligatorios');
        setLoading(false);
        return;
      }

      // Convertir precio a número
      const productData = {
        ...formData,
        prod_price: parseFloat(formData.prod_price),
        prod_stock: formData.prod_stock ? parseInt(formData.prod_stock) : 0
      };

      await axios.post('/api/products', productData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      // Limpiar el formulario
      setFormData({
        prod_code: '',
        prod_name: '',
        prod_description: '',
        prod_price: '',
        prod_stock: ''
      });

      // Notificar al componente padre
      onProductAdded();
    } catch (error) {
      console.error('Error al agregar producto:', error);
      setError(error.response?.data?.message || 'Error al agregar el producto. Por favor, inténtelo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="product-form-container">
      <h3>Agregar Nuevo Producto</h3>
      {error && <div className="error-message">{error}</div>}
      <form className="product-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="prod_code">Código de Barras</label>
          <input
            type="text"
            id="prod_code"
            name="prod_code"
            value={formData.prod_code}
            onChange={handleChange}
            placeholder="Código o clave del producto"
          />
        </div>
        <div className="form-group">
          <label htmlFor="prod_name">Nombre del Producto *</label>
          <input
            type="text"
            id="prod_name"
            name="prod_name"
            value={formData.prod_name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="prod_description">Descripción</label>
          <textarea
            id="prod_description"
            name="prod_description"
            rows="3"
            value={formData.prod_description}
            onChange={handleChange}
          ></textarea>
        </div>
        <div className="form-group">
          <label htmlFor="prod_price">Precio *</label>
          <input
            type="number"
            id="prod_price"
            name="prod_price"
            step="0.01"
            min="0"
            value={formData.prod_price}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="prod_stock">Stock</label>
          <input
            type="number"
            id="prod_stock"
            name="prod_stock"
            min="0"
            value={formData.prod_stock}
            onChange={handleChange}
          />
        </div>
        <div className="form-buttons">
          <button type="button" className="cancel-btn" onClick={onCancel} disabled={loading}>
            Cancelar
          </button>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProductForm;
